import * as React from "react"
import type { SVGProps } from "react"
const SvgHeartMini = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M7.98 14.67q-.36 0-.7-.14a2 2 0 0 1-.63-.4l-1.02-.93a35 35 0 0 1-3.19-3.17 5.3 5.3 0 0 1-1.4-3.6q0-1.72 1.14-2.86a4 4 0 0 1 2.89-1.15q.81 0 1.56.28.74.28 1.35.88.66-.6 1.38-.88.74-.28 1.53-.28A4 4 0 0 1 15 6.43q0 2.01-1.44 3.6a40 40 0 0 1-3.22 3.19l-1 .93a2 2 0 0 1-1.35.52M7.3 5.72q-.3-.6-.93-.96a2.5 2.5 0 0 0-1.3-.38q-.89 0-1.48.58T3 6.44q0 .81.57 1.7.59.91 1.38 1.76.8.86 1.64 1.6L8 12.72q.54-.5 1.4-1.24.86-.73 1.65-1.6.8-.84 1.4-1.73.57-.89.58-1.71 0-.9-.6-1.48a2 2 0 0 0-1.51-.58q-.69 0-1.32.38t-.92.96a.7.7 0 0 1-.29.31 1 1 0 0 1-.4.1 1 1 0 0 1-.4-.1 1 1 0 0 1-.28-.31" />
  </svg>
)
export default SvgHeartMini
